export default "__VITE_PUBLIC_ASSET__c23d3740__"